



































import { Component, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';

@Component
export default class VeicoloFilter extends Vue {

	advancedSearch: Search;

	searchParam: any = new class {
		plate: string = '';
		model: string = '';
	};

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('vehicle');
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);

		if (this.searchParam.plate) this.advancedSearch.addLikeFilter('plate', this.searchParam.plate);
		if (this.searchParam.model) this.advancedSearch.addLikeFilter('model', this.searchParam.model);

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.plate = '';
		this.searchParam.model = '';
		this.search();
	}

}
